var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 815,
    height: 1024,
    viewBox: "0 0 815 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 10C85 4.47715 89.4772 0 95 0H815V199H95C89.4772 199 85 194.523 85 189V10Z",
    fill: "#593122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105 209C105 203.477 109.477 199 115 199H815V352H115C109.477 352 105 347.523 105 342V209Z",
    fill: "#A6633C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 362C0 356.477 4.47715 352 10 352H815V505H9.99998C4.47713 505 0 500.523 0 495V362Z",
    fill: "#D99559"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151 515C151 509.477 155.477 505 161 505H815V724H161C155.477 724 151 719.523 151 714V515Z",
    fill: "#593122"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 734C85 728.477 89.4772 724 95 724H815V943H95C89.4772 943 85 938.523 85 933V734Z",
    fill: "#A6633C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 953C0 947.477 4.47715 943 10 943H815V1024H9.99998C4.47713 1024 0 1019.52 0 1014V953Z",
    fill: "#D99559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageBooks);
export default __webpack_public_path__ + "static/media/homePageBooks.e45eaddb46a1d0bdcf7fa67470f92add.svg";
export { ForwardRef as ReactComponent };